import { coreApi } from 'src/api/config';

const fetchCustomConsentAgreements = async ({ configurationId, language }) => {
  const response = await coreApi.query('custom_consent_agreement', {
    configuration_id: configurationId,
    state: 'active',
    language,
  });
  const agreement = response.data.data[0];
  return agreement;
};

export default fetchCustomConsentAgreements;
